export default __webpack_public_path__ + "static/media/Setting_DominionLordsUS.6287dc8c.svg";